export const specialistTypes = [
  {ja: "睡眠総合専門医・不眠症", en: "Insomnia Specialist"},
  {ja: "睡眠時無呼吸症候群・専門医", en: "SAS Specialist"},
  {ja: "こころの専門医", en: "Psychiatrist"},
]